import React, { useEffect } from "react";
import { SignUp } from "@clerk/clerk-react";
import logo from "../assets/images/png/WPC-logo-white.png";
import { Helmet } from "react-helmet-async";
const SignUpPage = () => {
  return (
    <>
      <Helmet>
        <title>Sign Up | Work Permit Consultancy</title>
        <meta
          name="description"
          content="Create your Work Permit Consultancy account to start your work permit application, track progress, and get expert immigration guidance."
        />
        <meta name="robots" content="noindex, nofollow" />{" "}
        {/* Prevents indexing of signup page */}
        {/* Open Graph / Social sharing */}
        <meta property="og:title" content="Sign Up - Work Permit Consultancy" />
        <meta
          property="og:description"
          content="Join now and begin your journey to secure an international work permit with our expert support."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.workpermitconsultancy.com/sign-up"
        />
        {/* Extra protection for auth pages */}
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>
      <div className="SignIn flex items-center justify-center lg:h-screen bg-cover bg-center relative">
        {/* Darken overlay */}
        <div className="absolute inset-0 bg-black opacity-30"></div>

        {/* Centered container */}
        <div className="relative flex  flex-wrap items-center justify-center z-10 my-[10%] rounded-lg max-w-[90%] lg:h-[98%] w-full text-center ">
          {/* First Div */}
          <div className="LoginFirstDiv w-full h-1/2 lg:w-1/2 lg:h-full p-4 lg:mb-0 flex flex-col justify-center items-center">
            <div className="w-[80%] m-[10%] lg:w-[60%]">
              <img
                src={logo}
                alt="Work Permit Consultancy"
                className="w-48 md:w-[21rem] mb-2 mx-auto"
              />
              <p className="text-[#dcdcdc] font-Poppins text-balance">
                Your trusted partner for obtaining work permits, specialize in
                simplifying the application process and providing expert
                consultancy services
              </p>
            </div>
          </div>

          {/* Second Div */}
          <div className="w-full h-1/2 lg:w-1/2 lg:h-full flex flex-col justify-center items-center bg-[#f4f7ff]">
            <div className="w-[95%]">
              <SignUp signInUrl="/sign-in" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUpPage;
